import React, { useState } from "react"
import { observer } from "mobx-react-lite"
import styled from "~/ui/styled"
import { ScrollView } from "~/ui/primitives"
import { Avatar } from "~widgets/avatar"
import {
  StartFlex,
  ColumnFlex,
  Text,
  BetweenFlex,
  IconFont,
  Button,
  CenterFlex,
  ColumnCenterFlex,
} from "~components/El"
import { flexPageContainer, scrollViewFillStyle } from "~/ui/scroll-layout"

const Container = styled.View`
  margin-bottom: ${({ theme }) => theme.space.xl};
  background-color: ${({ theme }) => theme.colors.blockBackground};
  ${flexPageContainer}
`
const TextInput = styled.TextInput`
  flex: 1;
  padding: 0 10px;
`

const Filters: React.FC<any> = ({ filters }) => {
  const [search, setSearch] = useState(filters.search || "")
  return (
    <ColumnFlex width="100%" padding="10px">
      <BetweenFlex width="100%" gap="12px">
        <StartFlex flex="1" height="40px" padding="10px" borderRadius="20px" bg="background">
          <IconFont name="ss" color={"secondaryText"} size={16} />
          <TextInput
            placeholder="搜索聊天内容"
            value={search}
            onChangeText={(text) => setSearch(text)}
          />
        </StartFlex>
        <StartFlex gap="10px">
          <Button disabled={!search} onClick={() => {}}>
            <CenterFlex
              bg={"buttonBackground"}
              borderRadius="20px"
              height="40px"
              width="80px"
              style={{
                opacity: !search ? "0.71" : "1",
              }}
            >
              <Text color={"#fff"}>搜索</Text>
            </CenterFlex>
          </Button>
        </StartFlex>
      </BetweenFlex>
    </ColumnFlex>
  )
}

const HighlightText = ({
  text,
  target,
  color,
  highlightColor,
  fontSize = "12px",
  style = {},
  highlightStyle = {},
}) => {
  if (!text || !target)
    return (
      <Text color="secondaryText" fontSize={fontSize} style={style}>
        {text}
      </Text>
    )
  const parts = text.split(target)
  return (
    <Text color={color} fontSize={fontSize} style={style}>
      {parts.map((part, index) => (
        <Text key={index}>
          {part}
          {index < parts.length - 1 && (
            <Text color={highlightColor} fontSize={fontSize} style={highlightStyle}>
              {target}
            </Text>
          )}
        </Text>
      ))}
    </Text>
  )
}

const Item: React.FC<any> = ({ item,search }) => {
  return (
    <BetweenFlex width="100%" padding="0 10px" height="66px" gap="10px">
      <Avatar
        size={48}
        avatar={null}
        name={item.name}
      />
      <ColumnFlex flex={1}>
        <BetweenFlex
          flex={1}
          style={{
            borderBottomColor: "#ccc",
            borderBottomWidth: "1px",
          }}
        >
          <CenterFlex flex={1} gap="4px" alignItems="flex-start" flexDirection="column">
            <StartFlex gap="3px">
              <Text color="text" fontWeight="600" fontSize={"16px"}>
                {item.name}
              </Text>
            </StartFlex>
            <HighlightText
              target={search}
              text={item.message}
              color="secondaryText"
              highlightColor="primary"
            />
          </CenterFlex>
          <StartFlex>
            <Text color="secondaryText" fontSize={"12px"}>
              {item.time}
            </Text>
          </StartFlex>
        </BetweenFlex>
        <CenterFlex height="1px" width="100%" bg="#e3e6ec" />
      </ColumnFlex>
    </BetweenFlex>
  )
}

const initialFilters = {
  search: "今天",
}
const Screen: React.FC<any> = (props) => {
  const [filters, setFilters] = useState(initialFilters)
  const setFilterValue = (updates) => {
    setFilters((prevFilters) => {
      const newFilters = { ...prevFilters }
      for (const [field, value] of Object.entries(updates)) {
        if (value === null) {
          delete newFilters[field]
        } else {
          newFilters[field] = value
        }
      }
      return newFilters
    })
  }
  const [data, setData] = useState([
    { id: 1, message: "今天天气不错", time: "16:30", name: "吴老弟" },
    { id: 2, message: "今天天气,不错", time: "16:30", name: "我" },
    { id: 3, message: "今天开黑不", time: "16:30", name: "吴老弟" },
    { id: 4, message: "今天运气爆棚", time: "16:30", name: "我" },
  ])
  return (
    <>
      <Container>
        <Filters filters={filters} setFilterValue={setFilterValue} />
        {data.length > 0 ? (
          <>
            <StartFlex padding="0 10px" height="32px" width="100%" bg="background">
              <Text color={"secondaryText"} fontSize="12px">
                {data?.length}条聊天记录
              </Text>
            </StartFlex>
            <ScrollView style={scrollViewFillStyle}>
              {data?.map((item, index) => {
                return <Item item={item} key={index} search={filters.search}/>
              })}
            </ScrollView>
          </>
        ) : (
          <ColumnCenterFlex width="100%" height="250px" gap="20px">
            <IconFont name="ss" color={"secondaryText"} size={40} />
            <Text color={"secondaryText"} fontSize="12px">
              未找到任何内容
            </Text>
          </ColumnCenterFlex>
        )}
      </Container>
    </>
  )
}

export default observer(Screen)
